export const conf2CustomerLogin = {
  type: "string",
  minLength: 1,
  maxLength: 255,
  transform: ["trim", "toLowerCase"]
};
